"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUserCheckCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zM9.979 6a3.447 3.447 0 011.017 6.741c2.171.434 3.85 2.226 3.956 4.325l.005.21v.341c0 .185-.13.34-.305.375l-.078.008H5.383a.383.383 0 01-.375-.306L5 17.617v-.34c0-2.19 1.718-4.088 3.961-4.538A3.445 3.445 0 019.98 6zm10.549 4.467a.75.75 0 01.077.976l-.072.085-2.971 3a.75.75 0 01-.975.078l-.084-.072-2.03-2a.75.75 0 01.969-1.14l.084.072 1.497 1.474 2.444-2.468a.75.75 0 011.06-.005z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgUserCheckCircle;
exports.default = _default;